module.exports = __webpack_public_path__ + "static/img/brees-2017-slide-3.a1fe451.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2017-slide-3.jpg
// module id = MxVw
// module chunks = 1